export const BACKEND_ADDRESS = process.env.PUBLIC_URL;
export const API_ADDRESS = `${BACKEND_ADDRESS}/api`;
export const API_MOCK_ENABLED = false;
